import {
  CHANGE_FILE,
  CLOSE_PLAYER,
  PAUSE,
  PLAY, SET_PLAYER
} from "./types";

export const setGlobalPlayerStatus = (status: string) => (dispatch: (any:any) => void) => {
  dispatch({
    type: status
  });
};

export const setGlobalPlayer = (player: HTMLAudioElement | undefined) => (dispatch: (any:any) => void) => {
  dispatch({
    type: SET_PLAYER,
    payload: { player }
  });
};

export const closeGlobalPlayer = () => (dispatch: (any:any) => void) => {
  dispatch({
    type: CLOSE_PLAYER
  });
};

export const setGlobalPlayerFile = (file: IFileItem) => (dispatch: (any:any) => void) => {
  dispatch({
    type: CHANGE_FILE,
    payload: { file }
  });
};

export const play = (post: IPostItem | IPostDetails, file?: IFileItem) => (dispatch: (any:any) => void) => {
  dispatch({
    type: PLAY,
    payload: { post, file: file || post.files[0] },
  });
};

export const pause = () => (dispatch: (any:any) => void) => {
  dispatch({
    type: PAUSE
  });
};
